import ArticleLayout from '@/components/feature/ArticleLayout';
import { sugargooBeginnerGuide } from '@/utils/articleContent';

export default function SugargooBeginnerGuidePage() {
  return <ArticleLayout article={sugargooBeginnerGuide} />;
}